module.exports = __webpack_public_path__ + "static/media/myaccount-1.d470b4cb.png";